import videojs from 'video.js';

window.videojs = videojs;
